import { CHART_CHROME, CHART_COLORS } from '../constants/chart.constants';

export const UNIFI_ECHARTS_THEME_NAME = 'unifi';

export const unifiEchartsTheme = {
  color: [...CHART_COLORS],
  backgroundColor: 'transparent',

  textStyle: {
    fontFamily: 'Inter, Lato, Arial, sans-serif',
    fontSize: 11,
    color: CHART_CHROME.label,
  },

  title: {
    textStyle: { color: '#212327', fontSize: 13, fontWeight: 600 },
    subtextStyle: { color: CHART_CHROME.label, fontSize: 11 },
  },

  grid: {
    left: 8,
    right: 8,
    top: 16,
    bottom: 8,
    containLabel: true,
  },

  categoryAxis: {
    axisLine: { show: false },
    axisTick: { show: false },
    splitLine: { show: false },
    axisLabel: { color: CHART_CHROME.label, fontSize: 11, margin: 10 },
  },
  valueAxis: {
    axisLine: { show: false },
    axisTick: { show: false },
    splitLine: {
      show: true,
      lineStyle: { color: CHART_CHROME.splitLine, width: 1, type: 'solid' },
    },
    axisLabel: { color: CHART_CHROME.label, fontSize: 11, margin: 10 },
  },
  logAxis: {
    axisLine: { show: false },
    axisTick: { show: false },
    splitLine: { show: true, lineStyle: { color: CHART_CHROME.splitLine } },
    axisLabel: { color: CHART_CHROME.label, fontSize: 11 },
  },
  timeAxis: {
    axisLine: { show: false },
    axisTick: { show: false },
    splitLine: { show: false },
    axisLabel: { color: CHART_CHROME.label, fontSize: 11 },
  },

  legend: {
    itemWidth: 8,
    itemHeight: 8,
    itemGap: 16,
    icon: 'circle',
    textStyle: { color: CHART_CHROME.label, fontSize: 11 },
  },

  tooltip: {
    backgroundColor: CHART_CHROME.tooltipBg,
    borderWidth: 0,
    padding: [6, 10],
    textStyle: { color: CHART_CHROME.tooltipText, fontSize: 12 },
    axisPointer: {
      lineStyle: { color: CHART_CHROME.splitLine, width: 1 },
      crossStyle: { color: CHART_CHROME.splitLine, width: 1 },
      shadowStyle: { color: CHART_CHROME.areaFill },
    },
  },

  line: {
    smooth: false,
    symbol: 'circle',
    symbolSize: 4,
    showSymbol: false,
    lineStyle: { width: 2 },
    itemStyle: { borderWidth: 0 },
  },

  bar: {
    itemStyle: { borderRadius: [2, 2, 0, 0] },
    barMaxWidth: 24,
  },

  pie: {
    itemStyle: { borderColor: '#ffffff', borderWidth: 2 },
    label: { color: CHART_CHROME.label, fontSize: 11 },
    labelLine: { lineStyle: { color: CHART_CHROME.splitLine } },
  },

  sankey: {
    itemStyle: { borderWidth: 0 },
    lineStyle: { color: 'gradient', opacity: 0.35 },
    label: { color: '#212327', fontSize: 11 },
  },

  heatmap: {
    itemStyle: { borderColor: '#ffffff', borderWidth: 1 },
  },
} as const;
